import { Message } from 'rsuite';
import { UserPanel } from '../UserPanel/UserPanel';
import { User } from '../../types/User';
import './style.css';

type ModalUserMessageProps = {
	user: User | null,
	message: string,
	type:  'info' | 'success' | 'warning' | 'error'	
}

export const ModalUserMessage = ({ user, message, type="error" }: ModalUserMessageProps) => {
	return (
		<div>
			<Message showIcon type={ type }>
				{ message === 'duplicate' && 'Participant has already been admitted previously' }
				{ message === 'admitted' && 'Participant admitted successfully' }
				{message === 'scanned-out' && 'Participant checked out successfully'}
				{ message !== 'duplicate' && message !== 'admited' && message !== 'scanned-out'  && message }
			</Message>
			{ user != null && <UserPanel user={ user } /> }
		</div>
	)
}
